/**
 * if token exist in user object it will set user object to storage
 * @param  {Object} user user object that contain token
 */
export function login(user) {
  if (user && user.token && user.token.length > 0) {
    localStorage.setItem("user", JSON.stringify(user));
  }
}
/**
 * it will remove user storage
 */
export function logout() {
  localStorage.removeItem("user");
}

/**
 * get user object from storage
 */
export function getUser() {
  return JSON.parse(localStorage.getItem("user"));
}

/**
 * check user exist and have token
 */
export function isLogin() {
  let user = getUser();
  return user && user.token && user.token.length > 0;
}
